import React from "react";
import { Route, Routes } from "react-router-dom";

import { AUTHENTICATED_ROUTES } from "../constants/routeConstants";

import Dashboard from "../screens/Dashboard";
import MainContent from "../layout/Main";
import Positions from "../screens/Positions";
import Holdings from "../screens/Holdings";
import Funds from "../screens/Funds";
import Orders from "../screens/Order";
import Advisors from "../screens/Advisors";
import NotifiedCalls from "../screens/NotifiedCalls";
import TradeHistory from "../screens/TradeHistory";
import PL from "../screens/PL";
import Edittrade from "../screens/Edittrade";
import ProfileSummary from "../screens/ProfileSummary.jsx";
import UnAuthenticated from "./UnAuthenticated";
import AdvisorProfile from "../screens/AdvisorProfile";
import AdvisorAccount from "../screens/AdvisorAccount";
import UserAccount from "../screens/UserAccount";
import FAQs from "../screens/FAQs";

export default function Authenticated({ authenticated }) {
  if (!authenticated) {
    
    return <UnAuthenticated />;
  }
  return (
    <MainContent>
      <Routes>
        <Route
          exact
          path={AUTHENTICATED_ROUTES.Dashboard_with_Params}
          element={<Dashboard />}
        />
        <Route
          exact
          path={AUTHENTICATED_ROUTES.DASHBOARD}
          element={<Dashboard />}
        />
        <Route path={AUTHENTICATED_ROUTES.POSITION} element={<Positions />} />
        <Route path={AUTHENTICATED_ROUTES.HOLDINGS} element={<Holdings />} />
        <Route path={AUTHENTICATED_ROUTES.FUNDS} element={<Funds />} />
        <Route path={AUTHENTICATED_ROUTES.ORDERS} element={<Orders />} />{" "}
        <Route path={AUTHENTICATED_ROUTES.ADVISORS} element={<Advisors />} />
        <Route
          path={AUTHENTICATED_ROUTES.NOTIFIED_CALLS}
          element={<NotifiedCalls />}
        />
        <Route
          path={AUTHENTICATED_ROUTES.PROFILE_SUMMARY}
          element={<ProfileSummary />}
        />
        <Route path="trade-history" element={<TradeHistory />} />
        <Route path="pl" element={<PL />} />
        <Route path="/summary/:id" element={<ProfileSummary />} />
        <Route path="/advisor/:id" element={<AdvisorProfile />} />
        <Route path="/edittrade" element={<Edittrade />} />
        <Route path="/user/account" element={<UserAccount />} />
        <Route path="/account" element={<AdvisorAccount />} />
        <Route path="/faqs" element={<FAQs />} />
      </Routes>
    </MainContent>
  );
}
